import * as React from "react";
import {
  Typography,
  useTheme,
  Popper,
  Paper,
  ClickAwayListener,
  Box,
  List,
  ListItemText,
  ListItemButton,
} from "@mui/material";

import { add, format, isValid, set } from "date-fns";
import { AppContext } from "../../contextProviders/AppContext";
import { translation } from "../Dictionary";

export default function FixedStartTimePicker({
  type,
  setSelectedPicker,
  selectedPicker,
  mobileViewPort,
}) {
  const theme = useTheme();
  const { language, selectedDateRange, locale, setSelectedDateRange } =
    React.useContext(AppContext);

  const [anchorPopper, setAnchorPopper] = React.useState(null);

  const ref = React.useRef(null);

  React.useEffect(() => {
    setAnchorPopper(ref.current);
  }, []);

  const handleChangeReservationDuration = (newValue) => {
    setSelectedDateRange((prevState) => {
      const start = set(prevState[0], {
        hours: newValue,
        minutes: 0,
      });

      const end = add(start, { hours: 5 });
      return [start, end];
    });
  };
  return (
    <Box>
      <Box
        ref={ref}
        onClick={() => setSelectedPicker("startTime")}
        sx={{
          height: "54px",
          display: "flex",
          paddingX: "10px",
          borderRadius: "10px",
          bgcolor: selectedPicker === type ? "white" : "transparent",
          boxShadow: selectedPicker === type ? theme.shadows[2] : "transparent",
          transition: "ease-in-out 250ms",
          alignItems: "center",
          justifyContent: "center",
          borderStyle: "solid",
          borderWidth: 2,
          borderColor: "transparent",
          cursor: "pointer",
          "&:hover": {
            bgcolor: "rgba(0,0,0,0.05)",
            boxShadow: theme.shadows[2],
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: theme.palette.primary.mainText,
          }}
        >
          <Typography>
            {translation.get(language, "Timepicker start title")}
          </Typography>
          <Typography>
            {isValid(selectedDateRange[0])
              ? format(new Date(selectedDateRange[0]), "HH:mm", {
                  locale: locale,
                })
              : ""}
          </Typography>
        </Box>
      </Box>
      <Popper
        id={"textIdPopper"}
        open={selectedPicker === "startTime"}
        anchorEl={anchorPopper}
        placement="bottom"
        /*   onBlur={() => setOpen(false)} */
        sx={{
          zIndex: 1000,
          offset: "25px",
          width: "100px",
        }}
      >
        <ClickAwayListener onClickAway={() => setSelectedPicker(null)}>
          <Paper
            elevation={3}
            sx={{
              borderRadius: "20px",
              paddingTop: "20px",
              marginTop: "7px",
            }}
          >
            <List>
              <ListItemButton
                onClick={() => handleChangeReservationDuration(8)}
              >
                <ListItemText
                  primary="8:00"
                  primaryTypographyProps={{
                    align: "center",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => handleChangeReservationDuration(9)}
              >
                <ListItemText
                  primary="9:00"
                  primaryTypographyProps={{
                    align: "center",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => handleChangeReservationDuration(13)}
              >
                <ListItemText
                  primary="13:00"
                  primaryTypographyProps={{
                    align: "center",
                  }}
                />
              </ListItemButton>
              <ListItemButton
                onClick={() => handleChangeReservationDuration(14)}
              >
                <ListItemText
                  primary="14:00"
                  primaryTypographyProps={{
                    align: "center",
                  }}
                />
              </ListItemButton>
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
}
